export default __webpack_public_path__ + "static/media/Cone.c42875e1.svg";